import React from 'react';

import Block from './Block';
import Console from '../../../../lib/debug';

const BlockList = props => {
    Console.render('designer.BlockList');
    let { blockKeys, session, dispatch } = props;
    let blocks = [];
    let count = blockKeys.length;
    let containsBlockBeingEdited = false;

    blockKeys.map((blockKey, i) => {
        let nextBlockKey = i + 1 < blockKeys.length ? blockKeys[i + 1] : null;
        let prevBlockKey = i - 1 < blockKeys.length ? blockKeys[i - 1] : null;
        let isLast = i + 1 === count;

        if (blockKey === props.blockLinkingKey) {
            containsBlockBeingEdited = true;
        }

        blocks.push(
            <Block
                key={blockKey}
                dispatch={dispatch}
                session={session}
                setKey={blockKey}
                prevSetKey={prevBlockKey}
                nextSetKey={nextBlockKey}
                isLast={isLast}
            />
        );
    });

    if (containsBlockBeingEdited) {
        let styleOverride = {
            opacity: 0.1,
            position: 'relative'
        };
        return (
            <div style={styleOverride}>
                {blocks}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        opacity: 0.01
                    }}
                />
            </div>
        );
    } else {
        return <div>{blocks}</div>;
    }
};

export default BlockList;



// WEBPACK FOOTER //
// ./src/view/designer/components/Block/BlockList.jsx